import type { ICommandPaletteItem } from "@dinesapp/dines-ui/components/CommandPalette/CommandPalette";
import { useRouter } from "next/router";
import { useVenue } from "@/hooks/useVenue";
import { GROUP_ORDER, ORG_COMMANDS } from "../Constants/commands";
import type { ICommandPaletteViewModel } from "../Types/CommandPaletteTypes";

const CommandPaletteViewModel = (): ICommandPaletteViewModel => {
  const router = useRouter();
  const { getFeatureFlags } = useVenue();
  const flags = getFeatureFlags();

  const visible = ORG_COMMANDS.filter((cmd) => {
    if (!cmd.featureFlag) return true;
    const enabled = flags[cmd.featureFlag];
    return cmd.flagInverse ? !enabled : enabled;
  });

  const commands: Array<ICommandPaletteItem> = visible.map((cmd) => ({
    id: cmd.id,
    label: cmd.label,
    keywords: cmd.keywords,
    group: cmd.group,
  }));

  const onSelect = (item: ICommandPaletteItem): void => {
    const cmd = ORG_COMMANDS.find((c) => c.id === item.id);
    if (!cmd) return;
    if (cmd.external) {
      window.open(cmd.path, "_blank", "noopener");
      return;
    }
    router.push(cmd.path);
  };

  return { commands, onSelect, groupOrder: GROUP_ORDER };
};

export default CommandPaletteViewModel;
